import React from "react";
import { usePageSettings } from "../../context/PageSettingsContext";
import type { SitePageKey } from "../../types/dataTypes";
import ErrorScreen from "../common/ErrorScreen";
import { getErrorDetails } from "../../utils/errorMapper";

interface PageAccessGuardProps {
  pageKey: SitePageKey;
  children: React.ReactNode;
}

const PageAccessGuard: React.FC<PageAccessGuardProps> = ({
  pageKey,
  children,
}) => {
  const { isPageEnabled, loading, error, refresh } = usePageSettings();

  if (loading) {
    return (
      <section className="container text-center text-light py-5">
        <div className="fw-semibold">Loading page settings…</div>
      </section>
    );
  }

  if (!isPageEnabled(pageKey)) {
    return (
      <section className="container text-center text-light py-5">
        <h2 className="fw-bold mb-3">Page temporarily unavailable</h2>
        <p className="text-muted">
          This section is currently disabled by the admin team. Please check
          back soon.
        </p>
      </section>
    );
  }

  if (error) {
    return (
      <section className="container py-5">
        <ErrorScreen {...getErrorDetails(error)} onRetry={refresh} />
      </section>
    );
  }

  return <>{children}</>;
};

export default PageAccessGuard;
